// src/router/gestaoAcesso.js
// Registrado automaticamente pelo auto-glob em src/router/index.js

import { ROLES_DA_AREA } from '@/views/GestaoAcesso/constants.js'

const gestaoAcessoBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Gestão de acesso',
    to: 'GestaoAcesso'
  }
]

// A API só aceita admin e gestao_acesso; sem o guard (meta.roles) a tela abriria e falharia em todas as chamadas.

export default [
  {
    path: '/gestao-acesso',
    name: 'GestaoAcesso',
    component: () => import('@/views/GestaoAcesso/GestaoAcessoPage.vue'),
    meta: {
      roles: ROLES_DA_AREA,
      title: 'Gestão de acesso',
      breadcrumb: gestaoAcessoBreadCrumb
    }
  },
  {
    path: '/gestao-acesso/usuarios/:id',
    name: 'GestaoAcessoUsuario',
    component: () => import('@/views/GestaoAcesso/Usuarios/UsuarioAcessoDetalhePage.vue'),
    meta: {
      roles: ROLES_DA_AREA,
      title: 'Usuário',
      breadcrumb: [
        ...gestaoAcessoBreadCrumb,
        {
          label: 'Usuário',
          to: 'GestaoAcessoUsuario'
        }
      ]
    }
  }
]
